import createIcon from '@/lib/create-icon'

const LoadingIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='48'
    height='48'
    viewBox='0 0 48 48'
    fill='none'
  >
    <path
      d='M24 48C10.7452 48 2.18624e-06 37.2548 2.76562e-06 24C3.34501e-06 10.7452 10.7452 -1.62846e-06 24 -1.04907e-06C37.2548 -4.69686e-07 48 10.7452 48 24C48 37.2548 37.2548 48 24 48ZM24 2.4C12.0707 2.4 2.4 12.0706 2.4 24C2.4 35.9293 12.0707 45.6 24 45.6C35.9293 45.6 45.6 35.9293 45.6 24C45.6 12.0706 35.9294 2.4 24 2.4Z'
      fill='#251929'
    />
    <path
      d='M46.8 24C47.4627 24 48.0031 24.5376 47.97 25.1995C47.8328 27.9414 47.226 30.6426 46.1731 33.1844C44.967 36.0962 43.1992 38.742 40.9706 40.9706C38.742 43.1992 36.0962 44.967 33.1844 46.1731C30.6426 47.226 27.9414 47.8328 25.1995 47.97C24.5376 48.0031 24 47.4627 24 46.8C24 46.1373 24.5377 45.6035 25.1994 45.5667C27.626 45.4317 30.0153 44.888 32.266 43.9558C34.8866 42.8703 37.2678 41.2793 39.2735 39.2735C41.2792 37.2678 42.8703 34.8866 43.9558 32.266C44.888 30.0153 45.4317 27.626 45.5667 25.1994C45.6035 24.5377 46.1373 24 46.8 24Z'
      fill='url(#paint0_linear_4380_29847)'
    >
      <animateTransform
        attributeName='transform'
        type='rotate'
        from='0 24 24'
        to='360 24 24'
        dur='1.5s'
        repeatCount='indefinite'
      />
    </path>
    <defs>
      <linearGradient
        id='paint0_linear_4380_29847'
        x1='24'
        y1='46.5'
        x2='48'
        y2='23.0588'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF78C4' />
        <stop offset='0.50775' stopColor='#D00376' stopOpacity='0.875' />
        <stop offset='1' stopColor='#20141A' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>,
  'LoadingIcon'
)

export default LoadingIcon
